export { default } from "bullitttime-embercomponents/utils/socket-record-table";
